import { Component } from '@angular/core';
import { Router } from '@angular/router';

interface StatCard {
  label: string;
  value: string;
  trend: string;
  icon: string;
  color: 'blue' | 'yellow' | 'purple' | 'green';
}

interface BroadcastItem {
  id: number;
  title: string;
  preview: string;
  audience: string;
  time: string;
  readPercent: number;
}

interface NotificationItem {
  id: number;
  text: string;
  time: string;
  unread: boolean;
}

interface MessageItem {
  id: number;
  name: string;
  initials: string;
  preview: string;
  time: string;
  unreadCount: number;
  color: string;
}

interface ActivityItem {
  id: number;
  text: string;
  meta: string;
  icon: string;
  color: 'green' | 'yellow' | 'purple' | 'blue';
}

@Component({
  selector: 'app-staff-home',
  templateUrl: './staff-home.component.html',
  styleUrls: ['../shared/staff-common.css', './staff-home.component.css']
})
export class StaffHomeComponent {
  staffFirstName = 'Priya';
  schoolName = 'Radiant Central Academy';
  today = 'Thu, 27 Aug 2026';

  stats: StatCard[] = [
    { label: 'totalStudents', value: '1,248', trend: '+24 this month', icon: 'ri-group-line', color: 'blue' },
    { label: 'broadcastsSent', value: '32', trend: 'this month', icon: 'ri-megaphone-line', color: 'yellow' },
    { label: 'unreadMessages', value: '14', trend: 'across 6 chats', icon: 'ri-chat-3-line', color: 'purple' },
    { label: 'newNotifications', value: '7', trend: '3 need action', icon: 'ri-notification-3-line', color: 'green' },
  ];

  broadcasts: BroadcastItem[] = [
    { id: 1, title: 'Holiday Announcement', preview: 'Dear parents, the school will remain closed tomorrow...', audience: 'All', time: 'Today · 3:00 PM', readPercent: 72 },
    { id: 2, title: 'PTM Schedule — Class 6', preview: 'Parent-teacher meeting scheduled for Saturday...', audience: 'Parents', time: 'Yesterday · 5:24 PM', readPercent: 58 },
    { id: 3, title: 'Staff Meeting Reminder', preview: 'All teaching staff to assemble in the hall at 9 AM...', audience: 'Staff', time: '20 Aug · 5:23 PM', readPercent: 91 },
  ];

  notifications: NotificationItem[] = [
    { id: 1, text: '3 admission enquiries awaiting review', time: '10 min ago', unread: true },
    { id: 2, text: 'Attendance not marked for Class 4-B', time: '1 hr ago', unread: true },
    { id: 3, text: 'New leave request from Priya Nair', time: '2 hrs ago', unread: true },
    { id: 4, text: 'Exam timetable published for Term 2', time: 'Yesterday', unread: false },
    { id: 5, text: 'Library books due reminder sent', time: 'Yesterday', unread: false },
  ];

  messages: MessageItem[] = [
    { id: 1, name: 'Vikram Sharma', initials: 'VS', preview: 'Is the fee receipt available to download?', time: '2 min', unreadCount: 2, color: 'blue' },
    { id: 2, name: 'Priya Nair', initials: 'PN', preview: 'Shared the updated Class 6 timetable.', time: '18 min', unreadCount: 1, color: 'purple' },
    { id: 3, name: 'Nilesh Patel', initials: 'NP', preview: 'Thank you for the quick response 🙏', time: '1 hr', unreadCount: 0, color: 'green' },
    { id: 4, name: 'Amit Desai', initials: 'AD', preview: 'Can we reschedule the meeting to Friday?', time: '3 hrs', unreadCount: 0, color: 'yellow' },
  ];

  activity: ActivityItem[] = [
    { id: 1, text: 'Ramesh Mishra admitted to Class IV-A', meta: '10 min ago · by demo', icon: 'ri-check-line', color: 'green' },
    { id: 2, text: 'Broadcast sent to all parents', meta: '2 hrs ago · Holiday notice', icon: 'ri-megaphone-line', color: 'yellow' },
    { id: 3, text: 'New staff added — Priya Nair', meta: 'Yesterday · Mathematics', icon: 'ri-user-add-line', color: 'purple' },
    { id: 4, text: 'Exam timetable published — Term 2', meta: 'Yesterday · by admin', icon: 'ri-calendar-line', color: 'blue' },
  ];

  constructor(private router: Router) {}

  goToClasses() {
    this.router.navigate(['/staff/classes']);
  }

  openChat() {
    this.router.navigate(['/staff/classes']);
  }
}
